import {
  faPhoneSlash,
  faMicrophone,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";

import {
  MuteButton,
  EndCallButton,
} from "./shared/ScribephoneButtons";

const CallControls = ({
  handleEndCall,
  toggleMute,
  isMuted,
  isDialing,
}) => (
  <>
    <div className="flex gap-3 mb-4">
      <MuteButton
        onClick={toggleMute}
        isMuted={isMuted}
        icon={isMuted ? faMicrophoneSlash : faMicrophone}
      >
        {isMuted ? "Unmute" : "Mute"}
      </MuteButton>
    </div>

    <EndCallButton
      onClick={handleEndCall}
      disabled={isDialing}
      icon={faPhoneSlash}
    />
  </>
);

export default CallControls;
